 <template>
     <div>
        <h4 class="p-2">Becas Asignadas</h4>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Ciclo escolar <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Institución" :key="cicloEscolarId" v-model="cicloEscolar" :disabled="!cicloEscolares.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <template v-if="cicloEscolares.length" autocomplete="off">
                            <vs-option v-for="option in cicloEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <div class="d-flex " style="justify-content: space-between;">
                    <label for="grupo" class="labelInput">
                        Grupo
                    </label>
                    <div class="d-flex" v-if="grupos[0]">
                        <div> 
                            <vs-tooltip>
                                <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(grupos, 'grupos')"></i>
                                <template #tooltip>
                                    Seleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        <div class="labelInput">
                            <vs-tooltip>
                                <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('grupos')"></i>
                                <template #tooltip>
                                    Deseleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        
                    </div>
                </div>
                <div style="position: relative">
                    <vs-select
                        filter
                        multiple
                        collapse-chips
                        :loading="loadingGrupo"
                        class="pt-0"
                        id="grupo"
                        placeholder="Seleccionar grupo"
                        :key="grupoId"
                        v-model="grupo"
                        :disabled="!grupos.length">
                        <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-button
                    class="ml-auto"
                    @click="getReporteBecas()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <tabla-becas :cards="cards" :users="users" :grupo="grupo" :institucion="institucion" :cicloEscolar="cicloEscolar"></tabla-becas>
     </div>
</template>

 <script>
import reportes from '../../../../api/requests/reportes.js'
import TablaBecas from './tabla-becas.vue'
export default {
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar:'',
            cicloEscolares: [],
            cicloEscolarId: (new Date()).getTime(),
            loadingCiclo: false,
            grupo: '',
            grupos: [],
            grupoId: (new Date()).getTime(),
            loadingGrupo: false,
            statu: '',
            status: [],
            statusId: (new Date()).getTime(),
            loadingstatus: false,
            errorFields: [],
            users: [],
            cards: [],
            page: 1
        }
    },
    components:{
        TablaBecas
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        selectAll(seleccion, tipo){
              let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'grupos'){
                this.grupo = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'grupos'){
                this.grupo = ''
            }
        },
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{

            }
        },
        async getCiclosEscolares(){
            try {
                this.loadingCiclo = true
                const response = await reportes.getCiclosEscolares(this.institucion)
                this.cicloEscolares = response.data
                this.cicloEscolarId = (new Date()).getTime()
                this.loadingCiclo = false
            }
            catch{

            }
        },
        async getGrupo() {
            if(this.institucion){
                this.loadingGrupo = true
                const params = {
                    ciclo_escolar_id: this.cicloEscolar
                }
                const { data: response } = await reportes.getGrupo(this.institucion, params)
                this.grupos = response
                this.grupoId = (new Date()).getTime()
                this.loadingGrupo = false
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.errorFields.length){
                const params = {
                    headers: ['persona_matricula', 'persona_nombre', 'persona_nivel_academico', 'persona_programa', 'beca_ciclo', 'beca_nombre', 'categoria_nombre' ],
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                    page: this. page,
                    grupo_id: this.grupo
                }

                if(this.grupo != ''){
                    if(this.grupo[0] == ''){
                        const eliminarGrupo = this.grupo.shift()
                        params.grupo_id = this.grupo
                    }else{
                        params.grupo_id = this.grupo
                    }
                }

                return params
            } else {
                return null
            }
        },
        async getReporteBecas(){
            const params = this.sanityForm()
            if(params){
                const loading = this.$vs.loading()
                try {
                    const { data: response } = await reportes.getReporteBecas(params)
                    this.users = response.data
                    this.cards = response.st
                    loading.close()
                }
                catch(error){
                    loading.close()
                    console.log(error)
                }
            }
        },
    },
    watch:{
        institucion(){
            this.cicloEscolar = ''
            this.cicloEscolares = []
            this.grupo = ''
            this.grupos = []
            this.getCiclosEscolares()
        },
        cicloEscolar(){
            this.getGrupo()
        }
    }
}
</script>